import { isProduction } from '@repo/environment';
import { useCallback, useEffect } from 'react';
export const pageview = (url)=>{
    var _window_dataLayer;
    (_window_dataLayer = window.dataLayer) === null || _window_dataLayer === void 0 ? void 0 : _window_dataLayer.push({
        event: "pageview",
        page: url
    });
};
export const useCustomEvent = function() {
    let eventName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'app-zephyr';
    var _window_dataLayer;
    (_window_dataLayer = window.dataLayer) === null || _window_dataLayer === void 0 ? void 0 : _window_dataLayer.push({
        event: eventName,
        page: window.location.pathname
    });
};
export const GoogleTagManager = (param)=>{
    let { children } = param;
    const location = window.location;
    const handleRouteChangeComplete = useCallback((url)=>{
        if (isProduction) {
            pageview(url);
        }
    }, []);
    useEffect(()=>{
        handleRouteChangeComplete(location.pathname);
    }, [
        location,
        handleRouteChangeComplete
    ]);
    return children;
};
